import httpClient from '../lib/http-client'
import { encrypt } from '../lib/utils'

const authApi = {
  signIn (model) {
    return httpClient.post('/signin', {
      ...model,
      password: encrypt(model.password, model.email)
    })
  },
  signOut () {
    return httpClient.post('/signout', {})
  }
}

export default authApi



// WEBPACK FOOTER //
// ./src/api/auth.js